import { Controller } from 'react-hook-form'

import { IOperatorProps } from './interface'
import { Multi } from '@/components/select/multi'

const Operator = ({ control, accountKey, loadOptions }: IOperatorProps) => {
  return (
    <Controller
      key={accountKey}
      name='operadora'
      control={control}
      render={({ field: { onChange, value } }) => (
        <Multi
          value={value}
          onChange={onChange}
          label='Operadora'
          loadOptions={loadOptions}
        />
      )}
    />
  )
}

export default Operator
